import { ROLES, USER_PROVISIONING_REQUEST_STATUS } from "@/constants/constants";
import { Session } from "next-auth";

export const getAidaRole = (aidaADGroup: string, selectedRole?: string): string => {
  if (aidaADGroup === ROLES.ADMIN) return "AIDA ADMIN";
  else if (selectedRole && selectedRole === ROLES.PARTNER) return "AGENCY ADMIN";
  return "AIDA USER";
};

export const getAdminOnboardingStatus = (session: Session) => {
  const isAdmin = session?.aidaADGroup === ROLES.ADMIN;
  const onboardingCompleated =
    session?.userProvisionRequest === USER_PROVISIONING_REQUEST_STATUS.APPROVED || !session?.userProvisionRequest;
  return {
    isAdmin,
    onboardingCompleated,
  };
};

const userAuthMessage = "User not authorized: ";
export const getUserNotAuthMessage = (txt: string) => userAuthMessage + txt;
